import { CSSProperties, FC, PropsWithChildren } from 'react';

import { IonAvatar } from '@ionic/react';
import { Color } from '@ionic/core';
import classNames from 'classnames';

import styles from './Avatar.module.scss';

export type AvatarProps = PropsWithChildren<{
  color?: Color;
  size?: number;
  className?: string;
  align?: CSSProperties['alignItems'];
  justify?: CSSProperties['justifyContent'];
}>;

export const Avatar: FC<AvatarProps> = ({
  children,
  color,
  size,
  className,
  align = 'center',
  justify = 'center',
}) => {
  return (
    <IonAvatar
      color={color}
      style={{
        width: size,
        height: size,
        alignItems: align,
        justifyContent: justify,
      }}
      className={classNames(styles.root, styles[color], className)}
    >
      {children}
    </IonAvatar>
  );
};
